import React, {useCallback, useState, useEffect} from 'react';
import SMCModal from '../../components/core/SMCModal';
import SMCModalBody from '../../components/core/SMCModal/SMCModalBody'
import {useTranslation} from 'react-i18next';
import SMCModalButtonContainer from '../../components/core/SMCModal/SMCModalButtonContainer';
import SMCButton from '../../components/Simple/SMCButton';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {hasValue} from '../../utils/utils';
import {SMCSelect} from '../../components/Simple/SMCSelect';

function SelectInputModal({
    isOpen = false,
    onRequestClose,
    onSuccess,
    title,
    label,
    labelWidth,
    height,
    width,
    defaultSelected,
    options
}) {
    const { t } = useTranslation();

    const [selectedOption, setSelectedOption] = useState('');

    const handleSubmit = useCallback(() => {
        onSuccess(selectedOption);
    }, [onSuccess, selectedOption]);

    // Reset values on open
    useEffect(() => {
        if (isOpen) {
            const defaultSelectedOption = hasValue(defaultSelected) ? defaultSelected : '';
            setSelectedOption(defaultSelectedOption);
        }
    }, [isOpen, defaultSelected]);
    
    return (
        <SMCModal
            isOpen={isOpen}
            width={width || 430}
            height={height || 200}
            title={title || 'Input'}
            onRequestClose={onRequestClose}
        >
            <SMCModalBody>
                <SMCSelect
                    label={label}
                    value={selectedOption}
                    onChange={e => setSelectedOption(e.target.value)}
                    labelWidth={labelWidth}
                >
                    {options}
                </SMCSelect>
            </SMCModalBody>
            <SMCModalButtonContainer
                left={
                    <SMCButton onClick={handleSubmit}>
                        <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="green" icon="check" />
                        {t('SMC_GEN_SUBMIT')}
                    </SMCButton>
                }
                right={
                    <SMCButton onClick={onRequestClose}>
                        <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="times" />
                        {t('SMC_GEN_CLOSE')}
                    </SMCButton>
                }
            />
            {/* Floating windows */}
            
        </SMCModal>

    );
}

export default SelectInputModal;